import {
  NoResultsRow,
  TableHeaderRow,
  TableRow,
  TableRowLoader,
} from "@ucchub/ui";
import Paragraph from "@vfuk/core-paragraph";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Heading from "@vfuk/core-heading";
import type { BillingProfiles } from "@components/billingProfiles/BillingProfilesList.types";

type Props = {
  isLoading: boolean;
  billingProfiles: BillingProfiles[];
};

const BillingProfilesList = ({ billingProfiles, isLoading }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Heading level={5} weight={3}>
        {t("core:accountConfig:billing_profiles")}
      </Heading>

      <TableHeaderRow
        headers={[
          t("core:accountConfig:profile_name"),
          t("core:accountConfig:profile_abbr"),
          t("core:accountConfig:default"),
        ]}
      />
      {isLoading && (
        <TableRowLoader rowCount={3} colCount={3} colWidths={["50%", "50%"]} />
      )}
      {!isLoading && billingProfiles?.length === 0 && (
        <NoResultsRow text={t("core:accountConfig:no_billing_profiles")} />
      )}
      {!isLoading &&
        billingProfiles?.map(({ name, id, isDefault }, index) => {
          const columns = [
            <Paragraph key={id?.abbreviation} noMargin weight={2}>
              {name}
            </Paragraph>,
            <Paragraph
              key={index + (id?.abbreviation || "-")}
              noMargin
              weight={2}
            >
              {id?.abbreviation}
            </Paragraph>,
            <Paragraph key={index} noMargin weight={2}>
              {isDefault
                ? t("core:accountConfig:yes")
                : t("core:accountConfig:no")}
            </Paragraph>,
          ];

          return (
            <TableRow
              key={`${name}-${id?.orgId}-${index}`}
              rowData={columns.map((column, i) => (
                <Fragment key={`row${i}`}>{column}</Fragment>
              ))}
              canViewIcon={false}
            />
          );
        })}
    </>
  );
};

export default BillingProfilesList;
